import { RootState } from "@/app/stores"
import { getPartnerTransactions, IGetPartnerTransactionsResults } from "@/shared/api/partners"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchPartnerTransactions = createAsyncThunk<
    IGetPartnerTransactionsResults,
    void,
    { state: RootState }
>('partnerTransactions/fetchPartnerTransactions', async (_, thunkAPI) => {
    try {
        const { clientType, storeId, partnerId, startDate, endDate, search, page, limit } = thunkAPI.getState().partnerTransactions
        const data = await getPartnerTransactions({
            page,
            limit,
            startDate,
            endDate,
            clientType,
            search,
            storeId,
            partnerId
        })
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})